import { render, staticRenderFns } from "./PDLI3.vue?vue&type=template&id=d792f052&scoped=true&"
import script from "./PDLI3.vue?vue&type=script&lang=js&"
export * from "./PDLI3.vue?vue&type=script&lang=js&"
import style0 from "./PDLI3.vue?vue&type=style&index=0&id=d792f052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d792f052",
  null
  
)

export default component.exports